






































































































import {Component, Vue} from "vue-property-decorator";
import DeleteButton from "@/components/datatable/DeleteButton.vue";
import EForm from "@/components/datatable/EForm.vue";
import Number from "@/components/inputs/Number.vue";
import TextField from "@/components/inputs/TextField.vue";
import EnabledSwitch from "@/components/inputs/EnabledSwitch.vue";
import {ActionsEnum} from "@/entity/ActionsEnum";
import Decimal from "@/components/inputs/Decimal.vue";
import ImageShow from "@/components/ImageShow.vue";
import ImageUpload from "@/components/inputs/ImageUpload.vue";

/** Tek bir taksit kademesi: bu tutardan itibaren en fazla şu kadar taksit. */
export class installmentTier {
  minAmount: number = 0;
  maxInstallment: number = 1;
}

export class config {
  phone: String = "";
  address: String = "";
  email: String = "";
  instagram: String = "";
  facebook: String = "";
  linkedin: String = "";
  twitter: String = "";
  watsappNo: String = "";
  watsappEnabled !: number;
  headerText: String = "";
  contactInfo: String = "";
  headerCss: String = "";
  logoSlogan: String = "";
  kargoTitle: String = "";
  kargoSlogan: String = "";
  blockTitle: String = "";
  blockSlogan: String = "";
  watermark: String = "";
  sanalPos: String = "";
  salterText: String = "";
  analytics: String = "";
  kepAdresi: String = "";
  vergiDairesi: String = "";
  vergiNumarasi: String = "";
  bagliBulunduguTicaretOdasi: String = "";
  mersisNumarasi: String = "";
  installmentRatio: number = 0;
  /**
   * Taksit kademeleri. Backend (App\Utils\InstallmentTiers) bu alanı otorite kabul eder.
   * EForm dizileri JSON string olarak POST eder; GET'te de string döner, parseTiers ile çözülür.
   */
  installmentTiers: installmentTier[] = [];
  // Eski alanlar: kademe hiç kaydedilmemiş kurulumlarda backend bunlara düşer.
  // Panelde gösterilmez ama kaydederken korunur (geriye dönük uyum bozulmasın).
  installmentablePrice: number = 0;
  maxInstallmentCount: number = 0;
  freeInstallmentPrice: number = 0;
  remarketing: String = "";
  limitedAdminHours: String = "";
  salter !: number;
  productListCount: number = 10;
  watermarkFile!: File;
  filterBrightness !: number;
  filterContrast !: number;
  imageFilterEnabled !: number;
  fileName: string = "watermark.png";
}

@Component({
  components: {
    ImageUpload,
    ImageShow,
    Decimal,
    DeleteButton, EForm, Number, TextField, EnabledSwitch
  }
})
export default class SiteConfig extends Vue {
  baseAction: string = ActionsEnum.Config;
  action: string = this.baseAction;
  data: config = new config();
  requestPayload: any = {
    file: !File
  }
  pos: any = [
    "ZiraatSanalPos",
    "GarantiSanalPos"
  ];
  randomNumber: number = 1;

  /** Backend ile aynı üst sınır (App\Utils\InstallmentTiers::MAX_INSTALLMENT). */
  maxInstallmentLimit: number = 12;

  /**
   * Sayıya çevirir. DİKKAT: bu dosyada global `Number`, @/components/inputs/Number.vue
   * import'u ile gölgelendiği için `Number(x)` KULLANILAMAZ (derleme hatası verir).
   */
  toNum(v: any): number {
    if (v === null || v === undefined || v === "") return NaN;
    return +v;
  }

  async get() {
    let response = await this.$http.get(this.action);
    this.data = response.data;
    // Kademe alanı config'te JSON string olarak durur (EForm/FormData nedeniyle).
    // Diziye çevir; alan hiç yoksa eski ayarlardan tohumla ki panel ilk açılışta
    // yürürlükteki EFEKTİF kuralı göstersin. Vue 2'de yeni alan için $set şart.
    this.$set(this.data, "installmentTiers", this.parseTiers(response.data));
    this.doFilter();
  }

  /**
   * Config'ten gelen kademe verisini (dizi | JSON string | yok) diziye normalize eder.
   * Backend (App\Utils\InstallmentTiers::tiersFor) ile AYNI kuralı uygular:
   *   alan yok/"" -> varsayılan merdiven; alan tanımlı -> otorite odur (boş dizi = taksit yok).
   */
  parseTiers(raw: any): installmentTier[] {
    let value: any = raw ? raw.installmentTiers : null;
    if (value === null || value === undefined || value === "") {
      return this.defaultTiers();
    }
    if (typeof value === "string") {
      try {
        value = JSON.parse(value);
      } catch (e) {
        // Çözülemeyen veri: backend bunu "taksit yok" sayar; panel de öyle göstermeli.
        return [];
      }
    }
    if (Array.isArray(value)) {
      return this.sanitizeTiers(value);
    }
    return [];
  }

  /**
   * Backend'deki App\Utils\InstallmentTiers::DEFAULT_TIERS ile AYNI olmalı.
   * Kademe hiç kaydedilmemişken sitede yürürlükte olan kural budur; panel bunu
   * göstermezse admin yanlış bir kuralı kaydeder.
   */
  defaultTiers(): installmentTier[] {
    return [
      {minAmount: 1500, maxInstallment: 3},
      {minAmount: 5000, maxInstallment: 6},
      {minAmount: 30000, maxInstallment: 12},
    ];
  }

  sanitizeTiers(list: any[]): installmentTier[] {
    return list
      .map((t: any) => ({minAmount: this.toNum(t && t.minAmount), maxInstallment: this.toNum(t && t.maxInstallment)}))
      .filter((t: installmentTier) => !isNaN(t.minAmount) && !isNaN(t.maxInstallment)
        && t.minAmount >= 0 && t.maxInstallment >= 1)
      .sort((a: installmentTier, b: installmentTier) => a.minAmount - b.minAmount);
  }

  addTier() {
    const tiers: installmentTier[] = this.data.installmentTiers || [];
    const last = tiers.length ? tiers[tiers.length - 1] : null;
    tiers.push({
      minAmount: last ? last.minAmount * 2 : 1500,
      maxInstallment: last ? Math.min(last.maxInstallment + 3, this.maxInstallmentLimit) : 3
    });
    this.$set(this.data, "installmentTiers", tiers);
  }

  removeTier(i: number) {
    this.data.installmentTiers.splice(i, 1);
  }

  /** Kaydetmeden önce kuralın sözlü hâli — kullanıcı sayıları değiştirdikçe canlı güncellenir. */
  /** Backend normalize() ile AYNI geçerlilik kuralı — panel neyi göstereceğini şaşırmasın. */
  get sortedTiers(): installmentTier[] {
    return (this.data.installmentTiers || [])
      .map((t: installmentTier) => ({minAmount: this.toNum(t.minAmount), maxInstallment: this.toNum(t.maxInstallment)}))
      .filter((t: installmentTier) => !isNaN(t.minAmount) && !isNaN(t.maxInstallment)
        && t.minAmount >= 0 && t.maxInstallment >= 1)
      .sort((a: installmentTier, b: installmentTier) => a.minAmount - b.minAmount);
  }

  get tierPreview(): string[] {
    const tiers = this.sortedTiers;
    if (!tiers.length) return [];
    const fmt = (n: number) => n.toLocaleString("tr-TR");
    const lines: string[] = [];
    lines.push(`${fmt(tiers[0].minAmount)} TL altı: taksit yok (tek çekim)`);
    tiers.forEach((t: installmentTier, i: number) => {
      const next = tiers[i + 1];
      const cap = Math.min(t.maxInstallment, this.maxInstallmentLimit);
      if (next) {
        lines.push(`${fmt(t.minAmount)} – ${fmt(next.minAmount)} TL arası: en fazla ${cap} taksit`);
      } else {
        lines.push(`${fmt(t.minAmount)} TL ve üzeri: en fazla ${cap} taksit`);
      }
    });
    return lines;
  }

  get tierWarnings(): string[] {
    const tiers = this.sortedTiers;
    const warnings: string[] = [];

    // Geçersiz satırlar backend'de sessizce atılır. Admin bunu ekranda görmezse
    // farkında olmadan taksidi kapatabilir; bu yüzden ham/geçerli farkını bildiriyoruz.
    const rawCount = (this.data.installmentTiers || []).length;
    const invalidCount = rawCount - tiers.length;
    if (rawCount === 0) {
      warnings.push("Hiç kademe yok — kaydedilirse hiçbir tutarda taksit yapılamaz.");
    } else if (tiers.length === 0) {
      warnings.push("Kademe satırlarının hiçbiri geçerli değil (tutar veya taksit alanı boş/hatalı) — kaydedilirse taksit tamamen kapanır.");
    } else if (invalidCount > 0) {
      warnings.push(`${invalidCount} kademe satırı geçersiz (tutar veya taksit alanı boş/hatalı) — kaydedilirken atılır.`);
    }

    if (tiers.some((t: installmentTier) => t.maxInstallment > this.maxInstallmentLimit)) {
      warnings.push(`${this.maxInstallmentLimit} üzeri taksit desteklenmiyor; kaydedilirken ${this.maxInstallmentLimit}'ye kırpılır.`);
    }
    const mins = tiers.map((t: installmentTier) => t.minAmount);
    if (new Set(mins).size !== mins.length) {
      warnings.push("Aynı başlangıç tutarına sahip birden fazla kademe var; yalnızca sonuncusu geçerli olur.");
    }
    for (let i = 1; i < tiers.length; i++) {
      if (tiers[i].maxInstallment < tiers[i - 1].maxInstallment) {
        warnings.push("Üst kademelerden birinin taksit sınırı alttakinden düşük — tutar arttıkça taksit azalır, istediğiniz bu mu?");
        break;
      }
    }
    return warnings;
  }

  async doFilter() {
    let response = await this.$http.post("imageFilter/" + this.data.filterBrightness + "/" + this.data.filterContrast);
    this.randomNumber = Math.floor(Math.random() * 1000);
  }

  created() {
    this.get();
  }
};
